import {Chart, ChartType, Plugin} from 'chart.js';
import {MathUtils, Utils} from '@astek/utils';

export type ChartAreaStylePluginOptions = {
  backgroundColors: Array<string>;
  borderColor: string;
  borderWidth: number;
  borderDash: Array<number>;
  borderDashOffset: number;
  borderRadius: number;
};

declare module 'chart.js' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/naming-convention
  interface PluginOptionsByType<TType extends ChartType = ChartType> {
    chartAreaBorder: ChartAreaStylePluginOptions;
  }
}

/**
 * Custom chart.js plugin for drawing a border around the chart area.
 */
export const chartAreaStylePlugin: Plugin = {
  id: 'chartAreaBorder',
  beforeDraw(chart: Chart, args, options: Partial<ChartAreaStylePluginOptions>) {
    if (Utils.isNullOrUndefined(options.backgroundColors)) {
      return;
    }
    const {ctx, chartArea: {left, top, bottom, width, height}} = chart;
    ctx.save();
    const gradient = ctx.createLinearGradient(left, top, left, bottom);
    ctx.fillStyle = gradient;
    for (let i = 0; i < options.backgroundColors.length; ++i) {
      gradient.addColorStop(i / (options.backgroundColors.length - 1), options.backgroundColors[i]);
    }
    ctx.beginPath();
    ctx.roundRect(left, top, width, height, Utils.valueOr(options.borderRadius, 0));
    ctx.fill();
    ctx.restore();
  },
  afterDraw(chart: Chart, args, options: Partial<ChartAreaStylePluginOptions>) {
    if (
      Utils.isNullOrUndefined(options.borderColor)
      || (Utils.isNotNullOrUndefined(options.borderWidth) && MathUtils.fuzzyNull(options.borderWidth))
    ) {
      return;
    }
    const {ctx, chartArea: {left, top, width, height}} = chart;
    ctx.save();
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth ?? 1;
    ctx.setLineDash(options.borderDash ?? []);
    ctx.lineDashOffset = options.borderDashOffset ?? 0;
    ctx.beginPath();
    ctx.roundRect(left, top, width, height, options.borderRadius ?? 0);
    ctx.stroke();
    ctx.restore();
  },
};
